import React from "react";
import "../../styles.css";

const ContactSection = () => {
  const whatsappNumber = "+91 86940-10200";
  const phoneNumber = "+91 86940-10200";
  const emailAddress = "support@zamzam.com";

  return (
    <section className="zamzam-contact-section">
      <div className="zamzam-contact-container">
        {/* Heading */}
        <h2 className="zamzam-contact-heading">Still have doubts?</h2>
        <h3 className="zamzam-contact-subheading"> Contact us directly </h3>
        {/* Buttons Container */}
        <div className="zamzam-button-group">
          {/* WhatsApp Button */}
          <a
            href={`https://wa.me/${whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="zamzam-btn"
          >
            {/* Fixed Complete Vector Stroke WhatsApp Icon */}
            <svg
              className="zamzam-icon-stroke"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
            </svg>
            WhatsApp Us
          </a>

          {/* Call Us Button */}
          <a href={`tel:${phoneNumber}`} className="zamzam-btn">
            <svg
              className="zamzam-icon-stroke"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            Call Us
          </a>

          {/* Mail Us Button */}
          <a href={`mailto:${emailAddress}`} className="zamzam-btn">
            <svg
              className="zamzam-icon-stroke"
              viewBox="0 0 24 24"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            Mail Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
